import Vue from "vue";
import Router from "vue-router";

//import Login from './components/Templates/modulos/Usuarios/Login'
//import registerusers from './components/Templates/modulos/Usuarios/registrousuarios'

//import maps from './components/Templates/modulos/Venta/maps'
//import Locales from './components/Templates/modulos/Empresa/locales'
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/confirmate/:id/:token",
      name: "ConfirmateEmail",
      component: () =>
        import("./components/Templates/modulos/Confirmate/confirmateemail"),
      meta: {
        title: "Espere un momento",
        //auth: false,
      },
    },
    {
      path: "/social/:id",
      name: "Indexloading",
      component: () =>
        import("./components/Templates/Views/loadingloginsocial"),
      meta: {
        title: "Cargando",
        //auth: false,
      },
    },
    {
      path: "/",
      name: "services",
      component: () => import("@/components/layauts/template-home.app.vue"),
      children: [
        {
          path: "/",
          name: "Index",
          component: () => import("./components/Templates/modulos/Index/index"),
          meta: {
            title: "Ayni - Bienvenido",
            //auth: false,
          },
        },
      ],
    },
    {
      path: "/app",
      name: "services", // rutas privadas
      component: () => import("./components/layauts/template.app.vue"),
      children: [
        {
          path: "/",
          name: "Index",
          component: () => import("./components/Templates/modulos/Index/index"),
          meta: {
            title: "Ayni - Bienvenido",
            //auth: false,
          },
        },

        {
          path: "/home",
          name: "Index",
          component: () => import("./components/Templates/modulos/Index/index"),
          meta: {
            title: "Ayni - Bienvenido",
            //auth: false,
          },
        },
        {
          path: "/conversation-user",
          name: "ProfileOfUser",
          component: () =>
            import("./components/Templates/modulos/Empresa/ProfileOfUser"),
          meta: {
            title: "GootWork",
            auth: true,
          },
        },

        {
          path: "/services/:id_company",
          name: "services/:id_company",
          component: () =>
            import("./components/Templates/modulos/Empresa/services"),
          meta: {
            title: "services",
            auth: true,
          },
        },
        {
          path: "/costumer-selected",
          name: "costumer-selected",
          component: () =>
            import("./components/Templates/modulos/Venta/selecteduser"),
          meta: {
            title: "Cliente",
            auth: true,
          },
        },
        {
          path: "/company/new-registro-user",
          name: "new-registro-user",
          component: () => import("./components/views/new-registro-user"),
        },
      ],
      meta: {
        title: "services",
        auth: true,
      },
    },
  ],
});
